import ButtonAction from "@visa/vds/button-action";
import ButtonLabel from "@visa/vds/button-label";
import ButtonMenu from "@visa/vds/button-menu";
import Icon from "@visa/vds/icon";
import Listbox from "@visa/vds/listbox";
import Navmenu from "@visa/vds/navmenu";
import React, { useEffect, useState } from "react";
import { ButtonText, ListboxItemContainer } from "@visa/vds";
import { CertificationWorkflowPackageStateConstant } from "_constants/CertificationWorkflowPackageStateConstants";
import { SubscriptionStatus } from "_constants/SubscriptionConstants";
import { trackPromise } from "react-promise-tracker";
import { certificationPackageListService } from "services/certification.packageList";
import { CERTIFICATION_PACKAGES_INFO_WITH_ID } from "_constants/PageRoutes";
import { useHistory } from "react-router-dom";
import { PACKAGE_LIST_INTERNAL_MENU_ITEMS } from "_constants/CertificationTestingConstants";
import AdminReactivateOrDeactivateVstsAccess from "pages/CertificationWorkflow/CertificationPackageList/Admin/AdminDeReactivateVstsAccess";
import AdminExtendSubscription from "pages/CertificationWorkflow/CertificationPackageList/Admin/AdminExtendSubscription";

function CertificationPackagesTableAction(props) {

  const [firstMenuBtnText, setFirstMenuBtnText] = useState("");
  const [isAdmin, setIsAdmin] = useState(null)
  const [isNonAdmin, setIsNonAdmin] = useState(null)
  const history = useHistory();

  const { user, packageState, currentSubscription, packageId } = props
  const externalUser = user && user.isExternalUser
  const [action, setAction] = useState(null);

  const [openAmendVstsAccessDialog, setOpenAmendVstsAccessDialog] = useState(false);
  const [openExtendVstsSubscriptionDialog, setOpenExtendVstsSubscriptionDialog] = useState(false);
  const [haveFutureSubscription, setHaveFutureSubscription] = useState(false);
  const [futureSubscription, setFutureSubscription] = useState(null);

  const menuBtnTextFunc = () => {
    const isAdmin = user && (user.isVstsWorkflowAdmin || user.isSuperAdmin)
    const isNonAdmin = !isAdmin && (user.isToolsAndLibAdmin || user.hasVisaInternalExtendedAccess)
    setIsAdmin(isAdmin)
    setIsNonAdmin(isNonAdmin)

    if (isNonAdmin) {
      setFirstMenuBtnText("View");
    } else if (packageState == CertificationWorkflowPackageStateConstant.Draft || packageState == CertificationWorkflowPackageStateConstant.Returned) {
      setFirstMenuBtnText("Continue")
    } else if (packageState === CertificationWorkflowPackageStateConstant.Reviewed
      || packageState === CertificationWorkflowPackageStateConstant.Testing
      || (packageState >= CertificationWorkflowPackageStateConstant.Canceled && packageState <= CertificationWorkflowPackageStateConstant.Completed)) {
      setFirstMenuBtnText("View")
    } else if (packageState === CertificationWorkflowPackageStateConstant.Pending) {
      setFirstMenuBtnText(externalUser ? "View" : "Review")
    } else if (packageState === CertificationWorkflowPackageStateConstant["Reviewed (Deferred)"]
      || packageState === CertificationWorkflowPackageStateConstant["Testing (Deferred)"]) {
      setFirstMenuBtnText(externalUser ? "Update Files" : "Review")
    }
  }

  // TODO Update button clicks for other actions
  const continueAction = () => {
    history.push({
      pathname: CERTIFICATION_PACKAGES_INFO_WITH_ID(packageId),
    })
  }


  useEffect(() => {
    menuBtnTextFunc()
  }, [user, packageState])

  const HandleActionMenuItemClick = (action) => {
    setAction(action)
    if (action == PACKAGE_LIST_INTERNAL_MENU_ITEMS.EXTEND_SUBSCRIPTION) {
      trackPromise(
        certificationPackageListService.AdminGetFutureSubscription(currentSubscription.bid)
          .then(result => {
            // BID has future subscriptin - unable to extend current subscription: to show warning dialog
            if (result.data.result != null) {
              setHaveFutureSubscription(true);
              setFutureSubscription(result.data.result)
            }
            setOpenExtendVstsSubscriptionDialog(true)
          })
          .catch(error => { })
      )
    } else { setOpenAmendVstsAccessDialog(true) }
  }

  return (
    <>
      <AdminReactivateOrDeactivateVstsAccess filters={props.filters} search={props.search} fetchData={props.fetchData} pagination={props.pagination}
        open={openAmendVstsAccessDialog} setOpen={setOpenAmendVstsAccessDialog} subscription={currentSubscription} action={action} companyName={props.companyName}
        vstsAccessObj={props.vstsAccessObj} sorter={props.sorter} />

      <AdminExtendSubscription filters={props.filters} search={props.search} fetchData={props.fetchData} pagination={props.pagination}
        open={openExtendVstsSubscriptionDialog} setOpen={setOpenExtendVstsSubscriptionDialog} subscription={currentSubscription} companyName={props.companyName}
        futureSubscription={futureSubscription} haveFutureSubscription={haveFutureSubscription} sorter={props.sorter} />
      <Navmenu
        className="actionMenu"
        placement="bottom-end"
        menu={
          <Listbox>
            <ListboxItemContainer>
              <ButtonText
                isFullWidth
                onClick={continueAction}
              >
                {firstMenuBtnText}
              </ButtonText>
            </ListboxItemContainer>
            {isAdmin && currentSubscription && (currentSubscription.subscriptionStatus === SubscriptionStatus.Active || currentSubscription.subscriptionStatus === SubscriptionStatus.Pending) &&
              <>
                <ListboxItemContainer>
                  <ButtonText
                    isFullWidth
                    onClick={() => HandleActionMenuItemClick(PACKAGE_LIST_INTERNAL_MENU_ITEMS.EXTEND_SUBSCRIPTION)}
                  >
                    Extend VSTS Subscription
                  </ButtonText>
                </ListboxItemContainer>
              </>
            }
            {isAdmin && props.vstsAccessObj && props.vstsAccessObj.accessDeactivated == false && props.vstsAccessObj.vstsAccess == true &&
              <>
                <ListboxItemContainer>
                  <ButtonText
                    isFullWidth
                    onClick={() => HandleActionMenuItemClick(PACKAGE_LIST_INTERNAL_MENU_ITEMS.DEACTIVATE_ACCESS)}
                  >
                    Deactivate VSTS Access
                  </ButtonText>
                </ListboxItemContainer>
              </>
            }
            {isAdmin && props.vstsAccessObj && props.vstsAccessObj.accessDeactivated == true &&
              <ListboxItemContainer>
                <ButtonText
                  isFullWidth
                  onClick={() => HandleActionMenuItemClick(PACKAGE_LIST_INTERNAL_MENU_ITEMS.REACTIVATE_ACCESS)}
                >
                  Reactivate VSTS Access
                </ButtonText>
              </ListboxItemContainer>
            }
          </Listbox >
        }
      >
        <ButtonMenu style={{ borderBottom: "2px solid #1434cb" }} flippable colorScheme="secondary">
          <ButtonLabel>Action</ButtonLabel>
          <ButtonAction>
            <Icon name="arrow-expand" resolution="tiny" />
          </ButtonAction>
        </ButtonMenu>
      </Navmenu >
    </>
  );
}

export default CertificationPackagesTableAction;
